module.exports = __webpack_public_path__ + "static/media/DAZN.11c5e81a.svg";